import { forwardRef, type TextareaHTMLAttributes } from 'react'

import { cn } from '@/lib/utils.ts'

export const TextArea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, rows = 4, ...props }, ref) => (
    <textarea
      rows={rows}
      className={cn(
        'rounded-allocated-radius flex min-h-9 w-full border border-gray-200 bg-transparent px-3 py-1 text-sm text-gray-500 transition-colors placeholder:text-gray-300 focus-visible:ring-1 focus-visible:ring-gray-500 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
)
